import { render, staticRenderFns } from "./TeamPeriodHeatmap.vue?vue&type=template&id=880c01d6&scoped=true&"
import script from "./TeamPeriodHeatmap.vue?vue&type=script&lang=js&"
export * from "./TeamPeriodHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./TeamPeriodHeatmap.vue?vue&type=style&index=0&id=880c01d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c01d6",
  null
  
)

export default component.exports